import * as A from "fp-ts/lib/Array";
import { pipe } from "fp-ts/lib/function";
import isEmpty from "lodash/isEmpty";
import React from "react";
import { AspectRatio, Button, HorizontalScroller, Image, Stack, Typography, } from "../components";
export const EmptyScreen = ({ title, subtitle, image, buttons, }) => {
    return (React.createElement(Stack, { height: "100%", width: "100%", sx: {
            padding: 8,
            gap: 4,
            border: 1,
            borderColor: (theme) => theme.palette.stroke[100],
            borderRadius: (theme) => theme.radius.xs4,
        } },
        React.createElement(Stack, { gap: 0.5, width: "100%" },
            typeof title === "string" ? (React.createElement(Typography, { variant: "h6", fontWeight: "bold" }, title)) : (title),
            React.createElement(Typography, { variant: "body1", sx: {
                    color: (theme) => theme.palette.disabled.onContainer,
                } }, subtitle)),
        buttons && (React.createElement(HorizontalScroller, null,
            React.createElement(Stack, { flexDirection: "row", gap: 2 }, pipe(buttons, A.filter((button) => !isEmpty(button)), A.mapWithIndex((index, button) => (React.createElement(Button, Object.assign({ key: index, variant: "outlined", density: "dense" }, button, { sx: Object.assign({ flexShrink: 0 }, button === null || button === void 0 ? void 0 : button.sx) })))))))),
        React.createElement(AspectRatio, { variant: "5/3", sx: {
                flex: "1 1 0",
            } },
            React.createElement(Image, { src: image, sx: {
                    height: "100%",
                    width: "100%",
                    objectFit: "contain",
                    objectPosition: "top left",
                } }))));
};
//# sourceMappingURL=EmptyScreen.js.map